<!--
 * @Author: awu
 * @Date: 2020-11-29 16:19:54
 * @LastEditors: awu
 * @LastEditTime: 2020-12-07 21:59:36
 * @Description: 选择展台
-->
<template>
    <div class="zhantai">
        <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
            <swiper-slide 
                style="position:relative" 
                v-for="(item,index) in swiperSlide" 
                :key="index"
            >
                <div class="box">
                    <img class="box-bc" :src="item.bcUrl" alt="">
                    <div 
                    v-for="(value,idx) in item.companyList"
                    :key="idx"
                        @click="goPath(value)" 
                        class="box-zt"  
                        :class="{zt1:idx==0,zt2:idx==1,zt3:idx==2}"                 
                    ></div>

                    <!-- <div @click="goPath('/area/ztDetail')" class="box-zt zt1"></div>
                    <div @click="goPath('/area/ztDetail')" class="box-zt zt2"></div>
                    <div @click="goPath('/area/ztDetail')" class="box-zt zt3"></div> -->
                </div>
            </swiper-slide>
        </swiper>
        <div class="arror" @click="prev()" style="left:22px">
            <img v-show="leftArrowFlag" src="../../assets/area/ll.png" alt="">
            <img v-show="!leftArrowFlag" src="../../assets/area/ll.png" alt="">
        </div>
        <div class="arror arr2" @click="next()" style="right:22px">
            <img v-show="rightArrowFlag" src="../../assets/area/rr.png" alt="">
            <img v-show="!rightArrowFlag" src="../../assets/area/rr.png" alt="">
        </div>
    </div>
</template>

<script>
// import area_22 from "@/utils/areaData/area22.js"
// import {
//     areaone,
//     areatwo,
//     areathree,
//     areafour,
//     areafive,
//     areasix,
//     areaseven,
//     areaeight,
//     areaten,
//     areaeleven,
    
// } from "@/utils/areaData"
import Lockr from 'lockr'
export default {
    data(){
        return{
            swiperOptions: {
                //设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next', 
                    prevEl: '.swiper-button-prev',
                    disabledClass: 'my-button-disabled',
                },
                on:{
                    slideChange:function(){
                        console.log(this.activeIndex)
                        Lockr.set("activeIndex",this.activeIndex)
                    }
                },
                loop:false,
                slidesPerView : 1,
                lidesPerGroup : 1,
            },
            leftArrowFlag:false,
            rightArrowFlag:true,
            slideNum:1,
            swiperSlide:[],
            swiperNum:"",
            exhibition_id: 14,
        }
    },
    mounted(){
        this.areaData()
        if(this.swiperNum !== 3){
            this.swiper.slideTo(Lockr.get("activeIndex"))
        }
        this.exhibition_id = this.$route.query.exhibition_id || 14
    },    
    methods:{
        areaData(){
            switch (this.$route.query.areaDate) {
                case '21':
                    this.swiperSlide = areaone
                    break;
                case '22':
                    this.swiperSlide = areatwo
                    break;
                case '23':
                    this.swiperSlide = areathree
                    break;
                case '24':
                    this.swiperSlide = areafour
                    break;
                case '25':
                    this.swiperSlide = areafive
                    break;
                case '37':
                    this.swiperSlide = areasix
                    break;
                case '35':
                    this.swiperSlide = areaeight
                    break;
                case '33':
                    this.swiperSlide = areaten
                    break;              
                case '32':
                    this.swiperSlide = areaeleven
                    break;
                case '36':
                    this.swiperSlide = areaseven
                    break;
            }  
            
        },
        goPath(value){
            console.log(value)
            
            if(value.company_id){
                Lockr.set("bc",value.bc)
                this.$router.push({
                    path:"/area/ztDetail",
                    query:{
                        company_id:value.company_id,
                        instance_id:value.instance_id,
                        exhibition_id: this.exhibition_id
                    }
                })
               
            }
            else{
                this.$message.error("暂无展台数据")
            }
        },
        prev(){
            this.swiper.slidePrev()
            this.slideNum--
            if(this.slideNum <= 1){
                this.slideNum = 1
            }
        },
        next(){
            this.swiper.slideNext()
            this.slideNum++
            if(this.slideNum >= this.swiperSlide.length){
                this.slideNum = this.swiperSlide.length
            }

        },
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    beforeRouteEnter (to, from, next) {
        console.log(from.path)
        if(from.path == "/area/zhanqu"){
            next(vm => {
                vm.swiperNum = 3
            })
            return
        }
        next()
        
    },
    watch:{
        slideNum(value){
            if(value<=1){
                this.leftArrowFlag = false
            }
            this.leftArrowFlag = value <= 1 ? false :true
            this.rightArrowFlag = value >= this.swiperSlide.length ? false :true
        },
        swiperSlide(value){
            if(value.length<=3){
                this.leftArrowFlag = false
                this.rightArrowFlag = false
            }
            else{
                this.leftArrowFlag = false
                this.rightArrowFlag = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .zhantai{
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        background-color: #fff;
        .aa{
            position: fixed;
            top: 40%;
            left: 50%;
            font-size: 60px;
        }
        .arror{
            width: 33px;
            height: 33px;
            background: rgba(0,0,0,0.45);
            border-radius: 17px;
            position: absolute;
            top: 50%;
            // left: 22px;
            z-index: 2;
            cursor: pointer;
            img{
                width: 35%;
                position: absolute;
                left: 45%;
                top: 50%;
                transform: translate(-50%,-50%);
            }
        }
        .arr2{
            >img{
                left: 55%; 
            transform: translate(-50%,-50%);
            }
           
        }
        .swiper{
            width: 100%;
            height: 100%;
            .box{
                width: 100%;
                height: 100%;
                position: relative;
                display: flex;
                align-items: center;
                &-bc{
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                &-zt{
                    width: 33%;
                    height: 60%;
                    opacity: 0.3;
                    cursor: pointer;
                    // background-color: red;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/area/zhantai.vue